import React, { useEffect } from 'react';
import { TranslationsContext, TranslationsContextWrapper, EnvironmentProvider, LanguageProvider, TRANSLATIONS_APP_NAME } from '@telia-common-components/shared';
import { useAnalytics } from 'telia-front-react';
import Telia1Store from '../stores/Telia1Store';
import Telia1BenefitsComponent from './Telia1BenefitsComponent';
let telia1Store;
const Telia1Benefits = (props) => {
    const analytics = useAnalytics();
    const { app, tier, language, customerId, renderAsOptionCards, onSelectedBenefitsChange, onBenefitsLoaded, invalid, saveStats } = props;
    const isLoggedIn = !!customerId;
    if (telia1Store === undefined) {
        telia1Store = new Telia1Store(tier, app, language, analytics, onSelectedBenefitsChange);
    }
    useEffect(() => {
        if (telia1Store !== undefined) {
            if (isLoggedIn) {
                telia1Store.evaluatePromotion(saveStats);
                telia1Store.fetchHasTelia1Products();
            }
            else {
                telia1Store.fetchBenefits();
            }
        }
    }, [customerId]);
    useEffect(() => {
        if (telia1Store !== undefined) {
            telia1Store.fetchIsEmployee(isLoggedIn);
        }
    }, [customerId]);
    return (React.createElement(EnvironmentProvider, { app: props.app, tier: props.tier },
        React.createElement(LanguageProvider, { lang: props.language },
            React.createElement(TranslationsContextWrapper, { isTestEnvironment: props.isTestEnvironment, disableStatistics: props.disableTranslationsStatistics },
                React.createElement(TranslationsContext.Consumer, null, ({ translateOrEmpty }) => (React.createElement(Telia1BenefitsComponent, { isLoggedIn: isLoggedIn, translate: (key, paramObject) => translateOrEmpty(TRANSLATIONS_APP_NAME, key, paramObject, false), telia1Store: telia1Store, renderAsOptionCards: renderAsOptionCards, onSelectedBenefitsChange: onSelectedBenefitsChange, onBenefitsLoaded: onBenefitsLoaded, invalid: invalid })))))));
};
export { Telia1Benefits };
